import { gql } from "graphql-request";

export const GET_CENSUS_TRADE_DATA = gql`
  query GetCensusTradeData($htsCode: String, $year: Int, $limit: Int) {
    getCensusTradeData(htsCode: $htsCode, year: $year, limit: $limit) {
      totalValue
      year
      dataByCountry {
        country
        totalValue
        percentage
        totalQuantity
        unit
        unitPrice
      }
    }
  }
`;

export const SEARCH_HTS_CODES = gql`
  query SearchHtsCodes($query: String!, $limit: Int) {
    searchHtsCodes(query: $query, limit: $limit) {
      hts_code
      description
    }
  }
`;

export const CALCULATE_DUTY_RATES_FOR_COUNTRIES = gql`
  query CalculateDutyRatesForCountries(
    $htsCode: String!
    $countries: [String!]!
    $effectiveDate: String
  ) {
    calculateDutyRatesForCountries(
      htsCode: $htsCode
      countries: $countries
      effectiveDate: $effectiveDate
    ) {
      htsCode
      effectiveDate
      htsDescription
      countryDutyRates {
        country
        countryCode
        totalDutyRate
        generalDutyRate
        additionalDutiesRate
        tariffBreakdown {
          name
          rate
          authority
        }
        error
      }
    }
  }
`;
